<ng-container *ifScreenSize="screenType.Mobile">
  <fgb-mobile-nav-menu></fgb-mobile-nav-menu>
  <ng-container *inPopulation="[population.Kids]">
    <div class="container py-3 bg-primary">
      <img class="kids-banner-img rounded" [src]="'banners/kids-banner.jpg' | contentAssetImage" />
    </div>
  </ng-container>
  <ng-container *notInPopulation="[population.Kids]">
    <div class="container py-3 bg-primary">
      <img class="kids-banner-img rounded" [src]="'banners/haws-rewards-banner.jpg' | contentAssetImage" />
    </div>
  </ng-container>
  <fgb-home-nav></fgb-home-nav>
</ng-container>

<ng-container *ifScreenSize="screenType.Desktop">
  <fgb-page-header [homepage]="true" [kidsBanner]="'banners/kids-banner.jpg'" [welcomeLink]="'/account'"></fgb-page-header>
</ng-container>

<fgbcl-loyalty-feed-list></fgbcl-loyalty-feed-list>
<div class="d-flex" [ngClass]="isKid ? 'flex-column-reverse' : 'flex-column'">
  <div class="container home-page">
    <!-- Featured Marketplace -->
    <ng-container *ngIf="mixedLoyaltyItems$ | async as mixedLoyaltyItems">
      <ng-container *ngIf="mixedLoyaltyItems.length">
        <div class="d-flex justify-content-between" [ngClass]="{ 'pt-lg-3': !isKid }">
          <h2 class="heading-title mt-0 text-white">
            <ng-container *notInPopulation="[population.Kids]">
              {{ 'featured.marketplace.experiences' | translate: { fgbdefault: 'Experiences & Rewards' } }}
            </ng-container>
            <ng-container *inPopulation="[population.Kids]">
              {{ 'featured.marketplace' | translate: { fgbdefault: 'Rewards' } }}
            </ng-container>
          </h2>
          <span class="d-flex align-items-center">
            <a class="home-link" [routerLink]="['/rewards/marketplace']">
              <span class="material-icons text-white">keyboard_arrow_right</span>
            </a>
          </span>
        </div>
        <owl-carousel-o [options]="customOptions">
          <ng-container *ngFor="let loyaltyItem of mixedLoyaltyItems">
            <ng-template carouselSlide [width]="mixedLoyaltyItems.length <= 2 ? rewardsWidth : 0">
              <ng-container [ngSwitch]="loyaltyItem.type">
                <ng-container *ngSwitchCase="'marketplace'">
                  <fgbcl-marketplace-list-item-v2 [marketplaceItem]="loyaltyItem.data"></fgbcl-marketplace-list-item-v2>
                </ng-container>
                <ng-container *notInPopulation="[population.Kids]">
                  <ng-container *ngSwitchCase="'lotto'">
                    <fgbcl-lottos-list-item-v2 [lottoItem]="loyaltyItem.data"></fgbcl-lottos-list-item-v2>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      </ng-container>
    </ng-container>
  </div>

  <!--Scorecard carousel-->
  <div class="mt-4">
    <fgbcl-scorecard-carousel [link]="'challenges'" [icon]="'chevron_right'" [showAllView]="true"></fgbcl-scorecard-carousel>
  </div>

  <!-- Vouchers -->
  <div [ngClass]="{ 'pt-lg-3': isKid }">
    <fgb-vouchers></fgb-vouchers>
  </div>
</div>

<!-- Offers -->
<ng-container *notInPopulation="[population.Kids]">
  <div class="mt-2">
    <fgb-campaigns-v2-offers-list
      [showAllOffers]="true"
      (dataChange)="onCampaignOfferListChange($event)"
    ></fgb-campaigns-v2-offers-list>
  </div>
</ng-container>

<div class="container">
  <!-- Featured Events -->
  <ng-container *notInPopulation="[population.Kids]">
    <ng-container *ngIf="marketplaceItems$ | async as marketplaceItems">
      <ng-container *ngIf="marketplaceItems.length">
        <div class="d-flex justify-content-between pt-3">
          <h2 class="heading-title mt-0 mb-0 text-white">{{ 'featured.events' | translate: { fgbdefault: ' Events' } }}</h2>
          <span class="d-flex align-items-center">
            <a class="home-link" [routerLink]="['/rewards/events']">
              <span class="material-icons text-white">keyboard_arrow_right</span>
            </a>
          </span>
        </div>
        <owl-carousel-o [options]="customOptions">
          <ng-container *ngFor="let marketplaceItem of marketplaceItems">
            <ng-template carouselSlide [width]="marketplaceItems.length <= 2 ? rewardsWidth : 0">
              <fgbcl-marketplace-list-item-v2 [marketplaceItem]="marketplaceItem"></fgbcl-marketplace-list-item-v2>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      </ng-container>
    </ng-container>
  </ng-container>

  <!-- Announcements -->
  <div class="mt-4">
    <fgbcl-announcements></fgbcl-announcements>
  </div>
</div>
